import { useCallback, useMemo } from 'react';

import { IUseQueryProps } from 'store/queries/types';
import { getQueryParams } from 'store/utils/getQueryParams';
import { useAppSelector } from 'store/useAppSelector';

import {
  IFetchDevdaoAccountJWTParams,
  selectDevdaoAccountJWT,
  selectDevdaoAccountJWTLoading,
  selectDevdaoAccountJWTState,
  useFetchDevdaoAccountJWTQuery,
  useLazyFetchDevdaoAccountJWTQuery,
} from '../fetchDevdaoAccountJWT';

export interface IUseDevdaoAccountJWTQueryProps
  extends IUseQueryProps,
    IFetchDevdaoAccountJWTParams {}

export const useDevdaoAccountJWTQuery = ({
  skipFetching,
  totp,
}: IUseDevdaoAccountJWTQueryProps) => {
  const params = useMemo(
    (): IFetchDevdaoAccountJWTParams => ({ params: undefined, totp }),
    [totp],
  );

  useFetchDevdaoAccountJWTQuery(getQueryParams({ params, skipFetching }));

  const [fetchLazy] = useLazyFetchDevdaoAccountJWTQuery();

  const handleFetchDevdaoAccountJWT = useCallback(
    () => fetchLazy(params),
    [fetchLazy, params],
  );

  const devdaoAccountJWT = useAppSelector(state =>
    selectDevdaoAccountJWT(state, params),
  );

  const loading = useAppSelector(state =>
    selectDevdaoAccountJWTLoading(state, params),
  );

  const state = useAppSelector(storeState =>
    selectDevdaoAccountJWTState(storeState, params),
  );

  return {
    devdaoAccountJWT,
    handleFetchDevdaoAccountJWT,
    loading,
    params,
    state,
  };
};
